export default __webpack_public_path__ + "static/media/Emerald Croc-hide Belt.05dd9bb3.jpg";